module.exports = __webpack_public_path__ + "media/staff/wilson-cruz-sound-53f7642a.jpg";